export default "__VITE_ASSET__ccLOXBpy__"